import type { Settings, SessionType } from '../types';

export const SOUND_PRESETS = [
  { label: 'Beep', path: '/audio/beep-alarm.mp3' },
  { label: 'None', path: '' },
] as const;

export const playAudio = async (audioPath: string, volume: number = 50): Promise<void> => {
  if (!audioPath) return;
  try {
    const audio = new Audio(audioPath);
    audio.volume = volume / 100;
    audio.preload = 'auto';
    audio.loop = false;

    try {
      await audio.play();
    } catch {
      const alt = new Audio(audioPath);
      alt.volume = volume / 100;
      alt.addEventListener('canplaythrough', () => {
        alt.play().catch(() => {});
      });
      alt.load();
    }

    audio.addEventListener('ended', () => audio.remove());
  } catch (error) {
    console.error('Audio playback failed:', error);
  }
};

// Request notification permission on demand — call on first Start click, not on page load.
export const ensureNotificationPermission = async (): Promise<boolean> => {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'default') {
    const result = await Notification.requestPermission();
    return result === 'granted';
  }
  return false;
};

export const playSessionCompleteSound = async (
  sessionType: SessionType,
  settings: Settings
): Promise<void> => {
  if (!settings.soundEnabled) return;
  const soundPath = sessionType === 'pomodoro'
    ? settings.workCompleteSound
    : settings.breakCompleteSound;
  await playAudio(soundPath, settings.volume);
};
